import { DELIVERY_ORDER_TYPE } from '../constants';
import { resolvePagePulseClickCategory } from './pulseChangeLocationClick';
import {
  PULSE_CLICK_ACTION,
  trackCartPageClick,
  trackPulseClick,
} from './pulseClickIds';
import { PULSE_VIEW_ID } from './pulseViewIds';

export type SlotSelectionKind = 'date' | 'time';

/** Pickup vs delivery slot modal — date or time action name. */
export const resolveSlotSelectionClickAction = (
  orderType: string,
  kind: SlotSelectionKind
): string => {
  const isDelivery = orderType === DELIVERY_ORDER_TYPE;
  if (kind === 'date') {
    return isDelivery
      ? PULSE_CLICK_ACTION.SELECT_DELIVERY_DATE
      : PULSE_CLICK_ACTION.SELECT_PICKUP_DATE;
  }
  return isDelivery
    ? PULSE_CLICK_ACTION.SELECT_DELIVERY_TIME
    : PULSE_CLICK_ACTION.SELECT_PICKUP_TIME;
};

const trackSelectSlotClick = ({
  isCartOpen,
  page_path,
  orderType,
  kind,
  label,
}: {
  isCartOpen: boolean;
  page_path?: string;
  orderType: string;
  kind: SlotSelectionKind;
  label: string;
}): void => {
  const action = resolveSlotSelectionClickAction(orderType, kind);
  const clickArgs = {
    action,
    label,
    page_path,
  };

  if (isCartOpen) {
    trackCartPageClick(clickArgs);
    return;
  }

  const path =
    page_path !== undefined
      ? page_path
      : typeof window !== 'undefined'
        ? window.location.pathname
        : '/';
  const category = resolvePagePulseClickCategory(path);

  trackPulseClick({
    category,
    action,
    label,
    view_id: PULSE_VIEW_ID.CAPACITY_SELECTOR_MODAL,
    page_id: category,
    page_path: path,
  });
};

/** Capacity modal — calendar date selected (pickup or delivery). */
export const trackSelectSlotDateClick = (params: {
  isCartOpen: boolean;
  page_path?: string;
  orderType: string;
  label: string;
}): void => {
  trackSelectSlotClick({ ...params, kind: 'date' });
};

/** Capacity modal — time slot selected (pickup or delivery). */
export const trackSelectSlotTimeClick = (params: {
  isCartOpen: boolean;
  page_path?: string;
  orderType: string;
  label: string;
}): void => {
  trackSelectSlotClick({ ...params, kind: 'time' });
};
